import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=c40a38b0&scoped=true&"
import script from "./Telegram.vue?vue&type=script&lang=js&"
export * from "./Telegram.vue?vue&type=script&lang=js&"
import style0 from "./Telegram.vue?vue&type=style&index=0&id=c40a38b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a38b0",
  null
  
)

export default component.exports